

exports.__esModule = true;
exports.$xoGenericMessagePageComponent = undefined;

var _squid = require('squid');

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

require('components/xo-models/src/checkout/index');

require('components/xo-ui-components/src/generic-message/directive');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoGenericMessagePageComponent = exports.$xoGenericMessagePageComponent = _squid.$Component.extend('$xoGenericMessagePageComponent', {
    tag: 'xo-generic-message-page',
    template: _template2['default'],

    controller: function controller($scope, $rootScope, // eslint-disable-line no-shadow
    $stateParams, $state, $logger, $CheckoutAppDataModel, $CheckoutCartModel, $ReturnToMerchant, $util, $q, $populate) {

        $scope.token = $rootScope.token;

        (0, _jquery2['default'])('#defaultCancelLink').hide();

        $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
            event.preventDefault();
        });

        $populate($scope, {
            appData: $CheckoutAppDataModel.instance($scope.token),
            cart: $CheckoutCartModel.instance($scope.token)
        });

        $scope.redirect = function (event) {
            event.preventDefault();
            var url = $scope.appData.get('urls.return_url');
            return $ReturnToMerchant.goTo($util.buildURL(url, {
                ba_token: $scope.cart.get('billing.ba_token')
            }));
        };
    }
});

angular.value("$xoGenericMessagePageComponent", $xoGenericMessagePageComponent);
_squid.$Component;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-generic-message/directive.js
// module id = ./pages/xo-generic-message/directive.js
// module chunks = 1